/**
 * Presets de "recordar luego" (snooze) para quick-picks fuera del detalle de
 * tarea — campanita de notificaciones y futuros consumidores.
 *
 * Cada preset devuelve un `remind_at` en ISO/UTC (lo que espera
 * core.task_reminders.remind_at). El despacho real del recordatorio lo maneja
 * la infra de reminders; acá solo calculamos el instante.
 */
export interface SnoozePreset {
  key: string;
  label: string;
  /** Instante del recordatorio en ISO (UTC). */
  at: () => string;
}

const iso = (d: Date) => d.toISOString();

export const SNOOZE_PRESETS: SnoozePreset[] = [
  {
    key: '1h',
    label: 'En 1 hora',
    at: () => {
      const d = new Date();
      d.setHours(d.getHours() + 1, 0, 0, 0); // a la hora en punto siguiente
      return iso(d);
    },
  },
  {
    key: 'evening',
    label: 'Esta tarde',
    at: () => {
      const d = new Date();
      // Si ya pasaron las 18, "esta tarde" cae a mañana 18:00.
      if (d.getHours() >= 18) d.setDate(d.getDate() + 1);
      d.setHours(18, 0, 0, 0);
      return iso(d);
    },
  },
  {
    key: 'tomorrow',
    label: 'Mañana 9:00',
    at: () => {
      const d = new Date();
      d.setDate(d.getDate() + 1);
      d.setHours(9, 0, 0, 0);
      return iso(d);
    },
  },
];
